import React from "react";
import "./style.css";
import Rating from "./Rating";
import ShowRating from "./ShowRating";
import store from './store/store';
import {Provider} from 'react-redux'
export default function App() {
  return (
    <Provider store={store}>
      <div>    
        <Rating />
        <ShowRating></ShowRating>
      </div>
    </Provider>
  );
}
